/* ==========================================================================
   AURIQUE — Night Cream Scroll-Scrubbed Section engine
   Same mechanism as aurique-hero.js, pointed at its own frame set, IDs and
   config so it runs fully independently alongside the day-cream hero.

   Frames are no longer preloaded here — aurique-preload.js loads BOTH the
   day-cream and night-cream frame sets together under one shared loading
   bar (#ahLoader) and fires "aurique:frames-ready" once everything has
   arrived. This file just listens for that event and grabs the night-cream
   frames from it.

   The 5 ingredient beats (previously 5 separate scroll scenes, cycling one
   ingredient at a time) are now a single scene: all 5 ingredient callouts
   fade in together, small text, while that portion of the scroll plays.
   ========================================================================== */

(function () {
  "use strict";

  var CONFIG = {
    frameCount: 170,
    /* [REVERT NOTE: Previous values were pxPerFrameDesktop: 36, pxPerFrameMobile: 24 (totaling ~7,000-8,000px scroll, which felt stuck).
       Optimized to 18px / 12px for snappy, fast, responsive scrubbing (~3,000px total scroll, matching Day Cream)].
       To revert: set pxPerFrameDesktop: 36, pxPerFrameMobile: 24 */
    pxPerFrameDesktop: 18,
    pxPerFrameMobile: 12,       // Snappy, fast scrub distance on mobile touchscreens
    mobileBreakpoint: 768
  };

  var root = document.getElementById("aurique-night-root");
  if (!root) return;

  var wrap = document.getElementById("nhScrollWrap");
  var canvas = document.getElementById("nhCanvas");
  var poster = document.getElementById("nhPoster");
  var ctx = canvas.getContext("2d");
  var railFill = document.getElementById("nhRailFill");
  var railLabels = Array.prototype.slice.call(document.querySelectorAll("#aurique-night-root .nh-rail-labels li"));
  var scrollCue = document.getElementById("nhScrollCue");
  var scenes = Array.prototype.slice.call(document.querySelectorAll("#aurique-night-root .nh-scene"));

  /* 4 scenes: Intro, Precision (cap lifting), Ingredients (all 5 shown
     together across the frame range where the jar's vacuum is open and 3D formula emerges), then
     Rest & Renew close. */
  /* [REVERT NOTE: Previously [0, 30, 114, 162, CONFIG.frameCount] with 4 scenes:
       0: Intro (0-30), 1: Precision (30-114), 2: Ingredients (114-162), 3: Rest & Renew (162-192).
       Precision text was merged into Scene 1, leaving 3 active scenes:
       0: Rejuvenate+ (0-114), 1: Ingredients (114-162), 2: Rest & Renew (162-192).
       To revert: set SCENE_BOUNDS = [0, 30, 114, 162, CONFIG.frameCount]; */
  var SCENE_BOUNDS = [0, 114, 148, CONFIG.frameCount];

  var images = null;
  var maxLoadedIndex = -1;
  var lastDrawnIndex = -1;
  var ticking = false;
  var wrapHeight = 0;
  var canvasCssW = 0, canvasCssH = 0, dpr = 1;
  var currentScene = -1;

  /* ---------------- Frames arrive from the shared preloader ---------------- */
  function onFramesReady(loadedImages) {
    images = loadedImages;
    maxLoadedIndex = CONFIG.frameCount - 1;
    currentIndex = targetIndex = getDesiredIndex();
    window.addEventListener("scroll", onScroll, { passive: true });
    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) {
      pageWrapper.addEventListener("scroll", onScroll, { passive: true });
    }
    window.addEventListener("resize", onResize);
    onResize();
    onScroll();
    drawFrame(getDesiredIndex(), true);
    if (poster) poster.classList.add("is-hidden");
  }

  window.addEventListener("aurique:frames-ready", function (e) {
    onFramesReady(e.detail.nightImages);
  });

  if (window.__auriqueFrames && window.__auriqueFrames.isReady) {
    onFramesReady(window.__auriqueFrames.nightImages);
  }

  function resizeCanvas() {
    var newCssW = canvas.parentElement.clientWidth;
    var newCssH = canvas.parentElement.clientHeight;
    // Prevent canvas context reset/flicker on mobile when URL bar collapses during scroll
    if (canvasCssW > 0 && Math.abs(newCssW - canvasCssW) < 2 && Math.abs(newCssH - canvasCssH) < 25) {
      return;
    }
    canvasCssW = newCssW;
    canvasCssH = newCssH;
    dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    canvas.width = Math.round(canvasCssW * dpr);
    canvas.height = Math.round(canvasCssH * dpr);
    canvas.style.width = canvasCssW + "px";
    canvas.style.height = canvasCssH + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    lastDrawnIndex = -1;
  }

  function setWrapHeight() {
    var isMobile = window.innerWidth < CONFIG.mobileBreakpoint;
    var pxPerFrame = isMobile ? CONFIG.pxPerFrameMobile : CONFIG.pxPerFrameDesktop;
    wrapHeight = CONFIG.frameCount * pxPerFrame + window.innerHeight;
    wrap.style.height = wrapHeight + "px";
  }

  function onResize() {
    setWrapHeight();
    resizeCanvas();
    drawFrame(lastDrawnIndex >= 0 ? getDesiredIndex() : 0, true);
  }

  function drawFrame(index, force) {
    if (!images) return;
    index = Math.max(0, Math.min(CONFIG.frameCount - 1, index));
    var safeIndex = Math.min(index, Math.max(maxLoadedIndex, 0));
    if (!force && safeIndex === lastDrawnIndex) return;
    var img = images[safeIndex];
    if (!img || !img.naturalWidth) return;

    var iw = img.naturalWidth, ih = img.naturalHeight;
    var isMobile = canvasCssW < CONFIG.mobileBreakpoint;
    /* Base cover scale for desktop/tablet */
    var scale = Math.max(canvasCssW / iw, canvasCssH / ih);

    /* On mobile screens, give the night jar elegant side breathing room (~7.5% per side)
       matching the Day Cream animation (Reference 1 & 3) rather than edge-to-edge clipping */
    if (isMobile) {
      var maxMobileJarWidth = canvasCssW * 0.85;
      var jarWidthInSource = 394; // Jar model width in 1280x720 render
      var mobileScale = maxMobileJarWidth / jarWidthInSource;
      if (mobileScale < scale) {
        scale = mobileScale;
      }
    }

    var dw = iw * scale, dh = ih * scale;
    var dx = (canvasCssW - dw) / 2;
    var dy = isMobile ? (canvasCssH - dh) * 0.18 : (canvasCssH - dh) / 2;

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.fillStyle = "#05070A";
    ctx.fillRect(0, 0, canvasCssW, canvasCssH);
    ctx.drawImage(img, dx, dy, dw, dh);
    lastDrawnIndex = safeIndex;
  }

  function getProgress() {
    var rect = wrap.getBoundingClientRect();
    var scrolled = -rect.top;
    var range = wrapHeight - window.innerHeight;
    if (range <= 0) return 0;
    var p = scrolled / range;
    return Math.max(0, Math.min(1, p));
  }

  function getDesiredIndex() {
    var p = getProgress();
    return p * (CONFIG.frameCount - 1);
  }

  function sceneForIndex(idx) {
    for (var s = 0; s < SCENE_BOUNDS.length - 1; s++) {
      if (idx >= SCENE_BOUNDS[s] && idx < SCENE_BOUNDS[s + 1]) return s;
    }
    return SCENE_BOUNDS.length - 2;
  }

  function updateScenes(idx, progress) {
    var roundedIdx = Math.round(idx);
    var scene = sceneForIndex(roundedIdx);

    var ingEl = document.getElementById("nhIngredients");
    var restEl = document.getElementById("nhScene8");

    // Rest & Renew closing CTA section activates at frame 148 through 170
    var isRestActive = roundedIdx >= 148;

    // Ingredients section is active from frame 114 to 147.
    // When Rest & Renew begins (frame 148+), ingredients hide completely on all screen sizes so only 'Wake up, transformed' is shown.
    var isIngredientsActive = roundedIdx >= 114 && !isRestActive;

    if (ingEl) {
      ingEl.classList.toggle("is-active", isIngredientsActive);
    }

    if (restEl) {
      restEl.classList.toggle("is-active", isRestActive);
    }

    // Update intro & precision scenes
    scenes.forEach(function (el, i) {
      if (el === ingEl || el === restEl) return;
      el.classList.toggle("is-active", i === scene && !isIngredientsActive && !isRestActive);
    });

    // Update rail active state
    railLabels.forEach(function (el, i) {
      var activeRailIndex = isRestActive ? 2 : (isIngredientsActive ? 1 : 0);
      el.classList.toggle("is-active", i === activeRailIndex);
    });

    if (railFill) railFill.style.height = (progress * 100) + "%";
    if (scrollCue) scrollCue.classList.toggle("is-hidden", progress > 0.03);
  }

  /* ---------------- LERP Smooth Scrub Engine ---------------- */
  var targetIndex = 0;
  var currentIndex = 0;

  function animLoop() {
    targetIndex = getDesiredIndex();
    var diff = targetIndex - currentIndex;

    if (Math.abs(diff) > 0.01) {
      currentIndex += diff * 0.28; // Smooth linear interpolation for butter-smooth animation
      var roundedIdx = Math.round(currentIndex);
      drawFrame(roundedIdx);
      updateScenes(roundedIdx, getProgress());
      requestAnimationFrame(animLoop);
    } else {
      currentIndex = targetIndex;
      var roundedIdx = Math.round(currentIndex);
      drawFrame(roundedIdx);
      updateScenes(roundedIdx, getProgress());
      ticking = false;
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(animLoop);
    }
  }

  setWrapHeight();
  resizeCanvas();
  window.addEventListener("resize", setWrapHeight);
})();
